import { useTranslation } from "react-i18next";

import type { PlaylistSummary } from "../api/types";

export interface PlaylistAddButtonProps {
  playlist: PlaylistSummary;
  alreadyAdded: boolean;
  isPending: boolean;
  onAdd: (playlistSlug: string) => void;
}

export function PlaylistAddButton({
  playlist,
  alreadyAdded,
  isPending,
  onAdd,
}: PlaylistAddButtonProps) {
  const { t } = useTranslation();
  const label = alreadyAdded
    ? t("playlistActions.inPlaylist", { playlist: playlist.name })
    : isPending
      ? t("playlistActions.addingPlaylist", { playlist: playlist.name })
      : t("playlistActions.addToPlaylist", { playlist: playlist.name });

  return (
    <button
      type="button"
      disabled={alreadyAdded || isPending}
      onClick={() => onAdd(playlist.slug)}
      className="rounded-md border border-stone-700 px-2.5 py-1 text-xs text-stone-200 transition-colors hover:bg-stone-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/60 focus-visible:ring-offset-2 focus-visible:ring-offset-stone-950 disabled:cursor-not-allowed disabled:border-stone-800 disabled:text-stone-500"
    >
      {label}
    </button>
  );
}
